
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.766 27.347c0-1.524.51-2.946 1.528-4.266 1.025-1.326 2.12-1.989 3.281-1.989.8 0 1.381.414 1.743 1.241.11-.547.39-.82.841-.82.376 0 .564.18.564.543 0 .096-.027.243-.082.441l-1.425 5.712c-.096.39-.144.748-.144 1.076 0 .574.181.858.544.851.52 0 .988-.83 1.405-2.491.054-.226.102-.363.143-.41.048-.049.133-.072.256-.072.212 0 .318.068.318.205 0 .027-.027.15-.082.369a10.92 10.92 0 01-.225.83 6.021 6.021 0 01-.329.862c-.375.786-.885 1.179-1.527 1.179-.404 0-.77-.123-1.098-.37-.32-.245-.536-.614-.646-1.107-.8.978-1.64 1.47-2.522 1.477-.772 0-1.391-.311-1.856-.933-.458-.63-.687-1.405-.687-2.328zm1.425.923c0 .465.086.892.257 1.282.17.39.471.584.902.584.52 0 1.063-.29 1.63-.871.568-.581.9-1.08.995-1.497l.985-3.969a.976.976 0 00.061-.276c0-.493-.133-.944-.4-1.354-.26-.41-.608-.615-1.046-.615-.417 0-.847.225-1.292.677-.437.444-.79.994-1.056 1.65-.212.492-.437 1.224-.677 2.195-.239.97-.359 1.702-.359 2.194zm1.856-10.418c0-.321.137-.622.41-.902.274-.28.585-.42.934-.42.266 0 .482.088.646.266.17.178.256.39.256.636 0 .335-.14.639-.42.912-.28.274-.588.41-.923.41a.918.918 0 01-.646-.246.888.888 0 01-.257-.656zm3.753 0c0-.321.134-.619.4-.892.267-.274.574-.41.923-.41.253 0 .468.085.646.256.185.171.277.386.277.646 0 .321-.137.619-.41.892-.267.274-.578.41-.933.41a.889.889 0 01-.657-.256.918.918 0 01-.246-.646z","fill":"currentColor"}})])
          )
        }
      }
    